export default {
  message: {
    "error": "ایک خرابی ہوئی!",
    "Sorrysomeerrorsoccurred": "معاف کیجیے کچھ غلطیاں ہوئیں",
    "quit": "خارج کریں",
    "language": "زبان",
    "Youcanchangethelanguagehere": "آپ یہاں زبان تبدل کر سکتے ہیں!",
    "current": "موجودہ",
    "home": "گھر",
    "friends": "دوست",
    "wallet": "والٹ",
    "aboutus": "ہمارے بارے میں",
    "Sharewithfriends": "دوستوں کے ساتھ شیئر کریں",
    "copyFailure": "کاپی میں ناکامی",
    "copySuccess": "کاپی کامیاب",
    "Claimreward": "انعام حاصل کریں",
    "DailyLogin": "روزانہ لاگ ان",
    "noInvitationsYet": "ابھی تک کوئی دعوت نہیں",
    "LoadMore": "مزید لوڈ کریں",
    "WatchAD": "اشتہار دیکھیں",
    "continue": "جاری رکھیں",
    "Congratulations": "مبارک ہو",
    "MyFriends": "میرے دوست",
    "Invitefriends": "دوستوں کو مدعو کریں",
    "Invitepremiumfriends": "پریمیم دوستوں کو مدعو کریں",
    "DailyTasks": "روزانہ کے کام",
    "inviteDesc": "ہر دوست کے لئے +{num} ${name}",
    "DailyTasksDesc": "زیادہ ${name} حاصل کرنے کے لیے کام مکمل کریں",
    "SponsorsandPartners": "حامی اور پارٹنرز",
    "Receivingwallet": "والمٹ حاصل کرنا",
    "Enterwalletaddress": "{name} والت کا پتہ درج کریں",
    "Claim": "حاصل کریں",
    "Booster": "بوسٹر",
    "RentPeriod": "کرایہ کی مدت",
    "days30": "30 دن",
    "days": "دن",
    "Dailyprofit": "روزانہ کا منافع",
    "Totalprofit": "مجموعی منافع",
    "Quantity": "مقدار",
    "RentPrice": "کرایہ کی قیمت",
    "RentMiner": "کان کن کرایہ پر لیں",
    "Insufficient": "ناکافی ${name}",
    "InsufficientMsg": "{num} ${name1} درکار ہیں، زیادہ ${name2} کمائے کے لیے دوستوں کو مدعو کریں یا کام مکمل کریں۔",
    "Settings": "ترتیبات",
    "copyid": "شناخت کاپی کریں",
    "UpgradeSuccessfully": "کامیابی سے اپ گریڈ کریں",
    "Name": "نام",
    "userinfo": "صارف کی معلومات",
    "disconnect": "منقطع کریں",
    "Startmining": "کان کنی شروع کریں",
    "Welcome": "میں خوش آمدید {name}",
    "Withdrawal": "نکالنا",
    "Minimumamount": "کم سے کم رقم",
    "Networkfee": "نیٹ ورک فیس",
    "Enteramount": "رقم درج کریں",
    "Submit": "جمع کروائیں",
    "MinimumTip": "نکالی گئی رقم بہت کم ہے۔ کم سے کم نکالی گئی رقم: {num}",
    "MaximumTip": "ناکافی رقم، زیادہ سے زیادہ آپ جس رقم کو نکال سکتے ہیں: {num}",
    "SubmittedTip": "جمع کروائی گئی، 30-60 کام کے دنوں کے اندر پروسیس ہونے کی توقع ہے",
    "WebSubmittedTip": "جمع کروائی گئی، 24-48 گھنٹوں کے اندر پروسیس ہونے کی توقع ہے",
    "WithdrawStatus": "حالت",
    "Submissiontime": "جمع کروانے کا وقت",
    "WithdrawAwaitTip": "* یہ تخمینہ لگایا گیا ہے کہ 30-60 کام کے دن لگیں گے۔ مزید دوستوں کو مدعو کرنے سے جائزے کے عمل کو تیز کیا جا سکتا ہے۔",
    "WebWithdrawAwaitTip": "* یہ تخمینہ لگایا گیا ہے کہ 24-48 گھنٹوں کے اندر ہوگا۔ مزید دوستوں کو مدعو کرنے سے جائزے کے عمل کو تیز کیا جا سکتا ہے۔",
    "Processing": "پروسیسنگ",
    "Success": "کامیابی",
    "Rejection": "داری",
    "Amount": "رقم",
    "Numberoffriends": "دوستوں کی تعداد: {now}/{limit}",
    "InviteTip": "اپنی پہلی واپسی کرنے کے لیے، آپ کو {limit} دوستوں کو مائننگ ایپ میں شامل کرنے کے لیے مدعو کرنا ہوگا۔",
    "openonphone": "اس لنک کو اپنے فون پر کھولیں۔",
    "claimTip": "جذب کرنے کے لیے رقم بہت کم ہے۔ کم سے کم جذب کرنے کے لیے رقم: {num}",
    "WalletBalance": "والٹ بیلنس",
    "Withdraw": "نکلوانا",
    "SetWalletAddress": "والٹ کا پتہ طے کریں",
    "WithdrawalRecord": "نکالنے کا ریکارڈ",
    "Norecords": "کوئی ریکارڈ نہیں",
    "Whatis": "{name} کیا ہے؟",
    "All": "سب",
    "save": "محفوظ کریں",
    "successWithdrawal": "نکالنے کی تصدیق ہو گئی {num}",
    "secondsago": "{time} سیکنڈ پہلے",
    "Loading": "لوڈ ہو رہا ہے...",
    "PaymentConfirming": "لین دین کی حیثیت چیک کر رہا ہے...",
    "Check": "چیک کریں",
    "CheckFail": "لین دین مکمل نہیں ہوا۔ براہ کرم 5 سیکنڈ کے بعد دوبارہ چیک کریں۔",
    "Addname": "'{name}' کو اپنے نام میں شامل کریں",
    "Restattcheck": "چیک کرنے کے لیے ایپ دوبارہ شروع کریں",
    "Copyname": "'{name}' کاپی کریں",
    "SubmissionFailed": "جمع کروانا ناکام رہا، براہ کرم بعد میں دوبارہ کوشش کریں",
    "WithdrawalReview": "نکالنے کا جائزہ",
    "shop": "دکان",
    "topurchase": "خریداری کے لیے دکان پر جائیں",
    "shopDesc": "محدود دستیابی—اپنا حاصل کریں اس سے پہلے کہ وہ غائب ہو جائیں!",
    "select_payment_method": "ادائیگی کا طریقہ منتخب کریں",
    "total_amount": "کل رقم",
    "creating_order": "آرڈر بن رہا ہے...",
    "order_created": "آرڈر بنایا گیا",
    "order_status": "آرڈر کی حیثیت",
    "claim": "اجازت",
    "payment_success": "ادائیگی کامیاب",
    "payment_failed": "ادائیگی ناکام",
    "payment_cancelled": "ادائیگی منسوخ",
    "opening_payment": "ادائیگی شروع ہو رہی ہے...",
    "payment_status": "ادائیگی کا درجہ",
    "create_order_failed": "آرڈر بنانے میں ناکامی",
    "creating_ton_order": "TON آرڈر بنا رہے ہیں...",
    "next_step": "اگلا قدم",
    "use_ton_payment": "TON ادائیگی استعمال کریں",
    "start_transaction": "ٹرانزیکشن شروع کریں",
    "connect_wallet": "والٹ سے جڑیں",
    "address": "پتا",
    "amount_ton": "رقم TON",
    "copy": "کاپی کریں",
    "amount": "رقم",
    "wallet_address": "والٹ کا پتا",
    "comment_memo": "تبصرہ نوٹ",
    "you_can_choose_to_connect_wallet_to_pay": "آپ ادائیگی کے لیے والٹ کو جڑنے کا انتخاب کر سکتے ہیں",
    "or_manually_transfer_to_the_above_address": "یا اوپر دیے گئے پتے پر دستی طور پر منتقل کریں (نوٹ کریں کہ رقم اور نوٹ بالکل ایک جیسی ہونی چاہئیں)",
    "transaction_success": "ٹرانزیکشن کامیاب",
    "transaction_failed": "ٹرانزیکشن ناکام",
    "transaction_error": "ٹرانزیکشن میں خرابی",
    "transaction_status": "ٹرانزیکشن کا درجہ",
    "transaction_id": "ٹرانزیکشن ID",
    "transaction_amount": "ٹرانزیکشن کی رقم",
    "transaction_status_desc": "ٹرانزیکشن کی حیثیت کی وضاحت",
    "payment_status_tip": "براہ کرم ادائیگی کی تصدیق ہونے کا انتظار کریں",
    "Applyforwithdrawal": "نکاسی کے لیے درخواست دیں",
    "Withdrawalunlock": "نکاسی کی انلاکنگ",
    "Close": "بند کریں",
    "Delivering": "پہنچانا",
    "Duetothelargenumber": "موصول کنندگان کی بڑی تعداد کی وجہ سے، آپ کی ایئرڈروپ 15-20 کام کے دنوں میں پہنچنے کی توقع کی جا رہی ہے",
    "WithdrawalunlockTip": "آپ کو نکاسی کو انلاک کرنے کے لیے {num} مدعو کردہ دوستوں کی ضرورت ہے",
    "select_network": "نیٹ ورک منتخب کریں",
    "confirm": "تصدیق کریں",
    "switching_network": "نیٹ ورک تبدیل ہو رہا ہے...",
    "network_switched": "نیٹ ورک تبدیل ہو گیا",
    "use_usdt_payment": "USDT کی ادائیگی کا استعمال کریں",
    "or_manually_transfer_to_the_above_address_usdt": "اوپر دی گئی ایڈریس پر دستی طور پر منتقل کریں (نوٹ کریں کہ رقم اور ایڈریس بالکل ایک جیسے ہونے چاہئیں)",
    "chain_type": "نیٹ ورک",
    "check_transaction_status": "لیندین کی حیثیت چیک کریں",
    "transaction_wait": "لیندین کی پروسیسنگ جاری ہے۔ آپ ایپ سے باہر نکل سکتے ہیں۔ ایک پیغام آپ کو اطلاع دے گا جب یہ مکمل ہو جائے گا۔",
    "twa_pay_tip_with_memo": "براہ کرم یقینی بنائیں کہ پتہ، رقم، اور میمو منتقلی کے لئے ہم آہنگ ہیں۔",
    "twa_pay_tip": "براہ کرم یقینی بنائیں کہ پتہ اور رقم منتقلی کے لئے درست ہیں۔",
    "creating_usdt_order": "USDT آرڈر بنارہا ہے...",
    "affiliate_programs": "ایفیلیٹ پروگرام",
    "affiliate_programs_description": "دوستوں کو مائننگ ایپ میں شامل ہونے کے لیے مدعو کریں اور انعامات حاصل کریں۔",
    "commission_details": "کمیشن کی تفصیلات",
    "no_commission_records": "کوئی کمیشن ریکارڈ نہیں",
    "commission_list": "کمیشن کی فہرست",
    "input_amount": "رقم درج کریں",
    "max": "زیادہ سے زیادہ",
    "commission_input_amount": "کمیشن کی رقم درج کریں",
    "min_commission": "کم از کم واپسی کی رقم {num} ہے",
    "WithdrawalSuccess": "واپسی کامیاب",
    "WithdrawalFailed": "واپسی ناکام",
    "WithdrawalProcessing": "واپسی کی پروسیسنگ",
    "award": "انعام",
    "level": "سطح",
    "Share_to_group": "گروپ میں شیئر کریں",
    "Exchange": "تبادلہ",
    "balance_not_enough": "بیلنس کافی نہیں ہے، آپ صرف {num} {coin} تبدیل کر سکتے ہیں",
    "exchange_fail": "تبادلہ ناکام ہو گیا",
    "exchange_success": "تبادلہ کامیاب ہوا",
    "you_will_receive": "آپ کو ملے گا",
    "ShareToGroups": "گروپوں میں شیئر کریں",
    "Numberofgroups": "گروپوں کی تعداد: {now}/{limit}",
    "Confirm": "تصدیق کریں",
    "ShareToGroupsDesc": "زیادہ {name} حاصل کرنے کے لئے گروپوں میں شیئر کریں",
    "TokenAddress": "براہ کرم واپسی کی تفصیلات درج کریں جیسے کہ ایکسچینج آئی ڈی یا USDT پتہ",
    "CashAddress": "براہ کرم واپسی کی تفصیلات درج کریں جیسے کہ بینک کارڈ نمبر یا USDT پتہ",
    "Cancel": "منسوخ کریں",
    "min_withdrawal_amount": "نکاسی کی کم از کم رقم {num} {coin} ہے",
    "max_withdrawal_amount": "نکاسی کی زیادہ سے زیادہ رقم {num} {coin} ہے",
    "withdrawal_failed": "نکاسی ناکام ہوگئی",
    "withdrawal_success": "انخلا کامیاب",
    "PayNow": "اب ادا کریں",
    "PaySkip": "فوری نکلوانے کے لیے {num} ادا کریں",
    "NumberofGroups": "گروپوں کی تعداد: {now}/{limit}",
    "SendMessage": "پیغام بھیجیں",
    "NumberofShares": "شیئرز کی تعداد: {now}/{limit}",
    "NumberofTasks": "کاموں کی تعداد: {now}/{limit}",
    "CompleteTask": "کام مکمل کریں",
    "PleaseEnterValidAmount": "براہ کرم درست رقم درج کریں",
    "PleaseEnterValidEmail": "براہ کرم درست ای میل درج کریں",
    "Feedback": "آراء",
    "Inputfeedbackcontent": "آراء کا مواد درج کریں",
    "Submitfeedback": "آراء جمع کروائیں",
    "Pleaseenteravalidemailaddress": "براہ کرم ایک درست ای میل ایڈریس درج کریں",
    "Pleaseenteryouremailaddress": "براہ کرم اپنی ای میل ایڈریس درج کریں",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "آپ نے آج پہلے ہی آراء دی ہے، براہ کرم کل واپس آئیں",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "آراء کامیابی سے جمع کر دی گئی، آپ کی قیمتی آراء کا شکریہ",
    "Feedback_submission_failed_please_retry": "آراء جمع کرنے میں ناکامی، براہ کرم دوبارہ کوشش کریں",
    "ContactUs": "ہم سے رابطہ کریں",
    "XRPAddress": "براہ کرم متحرک XRP چین والیٹ کے پتے کو پر کریں (MEMO سمیت)، ورنہ آپ نقدی نکالنے میں ناکام رہیں گے۔",
    "Accelerated": "تیز رفتار",
    "Accelerated_withdrawals_success": "تیز رفتار رقم کی واپسی کامیابی سے",
    "login": "لاگ ان",
    "register": "رجسٹریشن",
    "login_with_google": "گوگل کے ساتھ لاگ ان کریں",
    "or": "یا",
    "email": "ای میل",
    "password": "پاسورڈ",
    "no_account": "کیا آپ کے پاس اکاؤنٹ نہیں ہے",
    "click_to_go": "کلک کریں تاکہ",
    "have_account": "کیا آپ کے پاس پہلے سے ایک اکاؤنٹ ہے",
    "go_to": "جائیں",
    "invite_code": "دعوت کوڈ",
    "optional": "اختیاری",
    "google_login_not_ready": "گوگل لاگ ان تیار نہیں ہے، براہ کرم بعد میں دوبارہ کوشش کریں",
    "password_too_long": "پاسورڈ بہت لمبا ہے",
    "weak": "کمزور",
    "medium": "درمیانہ",
    "strong": "مضبوط",
    "login_success": "لاگ ان کامیاب",
    "login_failed": "لاگ ان ناکام",
    "please_input_email": "براہ کرم اپنی ای میل درج کریں",
    "invalid_email": "غیر درست ای میل فارمیٹ",
    "please_input_password": "براہ کرم اپنا پاسورڈ درج کریں",
    "password_length_6_to_16": "پاسورڈ 6-16 حرف کا ہونا چاہیے",
    "account_or_password_error": "اکاؤٹ یا پاسورڈ میں غلطی",
    "register_success": "رجسٹریشن کامیاب",
    "register_failed": "رجسٹریشن ناکام",
    "save_error": "خرابی محفوظ کریں، براہ کرم بعد میں دوبارہ کوشش کریں",
    "ShareToFriends": "دوستوں کے ساتھ شیئر کریں",
    "login_first": "براہ کرم پہلے لاگ ان کریں",
    "WalletBscError": "❌ غیر موثر BNB چین والیٹ کا پتہ۔",
    "DownloadWallet": "روشن والاٹ ڈاؤن لوڈ کریں",
    "AddToHomeScreen": "ہوم اسکرین میں {appName} شامل کریں",
    "TapShareInToolbar": "ٹول بار میں ٹیپ کریں",
    "SelectAddToHomeScreen": "ہوم اسکرین میں شامل کریں منتخب کریں",
    "OpenToolbar": "ٹول بار کھولیں",
    "ClaimFailed": "انعام حاصل کرنے میں ناکامی، براہ کرم بعد میں دوبارہ کوشش کریں",
    "guest_login": "مہمان لاگ ان",
    "please_input_phone": "براہ کرم اپنا فون نمبر درج کریں",
    "email_error_1": "براہ کرم اپنا ای میل درج کریں",
    "email_error_2": "براہ کرم ایک درست ای میل ایڈریس درج کریں",
    "email_error_3": "مہمان ای میل کی اجازت نہیں ہے، براہ کرم ایک حقیقی ای میل استعمال کریں",
    "phone": "فون",
    "phone_error_1": "براہ کرم اپنا فون نمبر درج کریں",
    "phone_error_2": "براہ کرم ایک درست فون نمبر درج کریں",
    "update_info": "معلومات کو اپ ڈیٹ کریں",
    "update_success": "اپ ڈیٹ کامیاب",
    "update_failed": "اپ ڈیٹ ناکام، براہ کرم بعد میں دوبارہ کوشش کریں",
    "cancel": "کینسل کریں",
    "guest_credentials_title": "اکاؤنٹ کی معلومات",
    "guest_credentials_warning": "براہ کرم اپنے اکاؤنٹ اور پاسورڈ کو محفوظ کرنے کے لئے اسکرین شاٹ لیں۔ اگر کھو گیا، تو آپ کی کمائی واپس نہیں کی جا سکتی!",
    "i_have_saved": "میں نے محفوظ کیا ہے",
    "account": "اکاؤنٹ",
    "view_credentials": "اسناد دیکھیں",
    "miner_max_reached": "آپ اس مائنر کی زیادہ سے زیادہ تعداد پر پہنچ چکے ہیں"
}};